<template>
  <button @click.prevent="$emit('click')" ref="button">
    <div style="height: 0; width: 0; position: absolute; visibility: hidden;" aria-hidden="true">
      <svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" focusable="false">
        <symbol id="ripply-scott" viewBox="0 0 100 100">
          <circle id="ripple-shape" cx="1" cy="1" r="1" />
        </symbol>
      </svg>
    </div>
    <slot/>
    <svg class="ripple-obj" id="js-ripple">
      <use height="100" width="100" xlink:href="#ripply-scott" class="js-ripple"></use>
    </svg>
  </button>
</template>

<script>
  export default {
    name: "CustopButton",
    props: {
      component: {
        type: String,
        default: 'button'
      }
    },
    mounted() {
      let context = this;
      let ripplyScott = (function() {
        let circle = document.getElementById('js-ripple'),
          ripple = document.querySelectorAll('.js-ripple');

        function rippleAnimation(event, timing) {
        let tl           = new TimelineMax(),
            x            = event.offsetX,
            y            = event.offsetY,
            w            = event.target.offsetWidth,
            h            = event.target.offsetHeight,
            offsetX      = Math.abs( (w / 2) - x ),
            offsetY      = Math.abs( (h / 2) - y ),
            deltaX       = (w / 2) + offsetX,
            deltaY       = (h / 2) + offsetY,
            scale_ratio  = Math.sqrt(Math.pow(deltaX, 2) + Math.pow(deltaY, 2));

          tl.fromTo(ripple, timing, {
            x: x,
            y: y,
            transformOrigin: '50% 50%',
            scale: 0,
            opacity: 1,
            ease: Linear.easeIn
          },{
            scale: scale_ratio,
            opacity: 0
          });

          return tl;
        }

        return {
          init: function(target, timing) {
            let button = context.$refs.button;
            button.addEventListener('click', function(event) {
              rippleAnimation.call(this, event, timing);
            });
          }
        };
      })();

      ripplyScott.init('js-ripple-btn', 0.75);
    }
  }
</script>

<style lang="scss">
  @import "../style/var";

  .ripple-obj {
    height: 100%;
    pointer-events: none;
    position: absolute;
    top: 0;
    left: 0;
    z-index: 0;
    width: 100%;
    fill: darken($blue, 20);
  }

  .ripple-obj use {
    opacity: 0;
  }

  .btn {
    position: relative;
    display: inline-block;
    padding: 12px 47px;
    font-size: 16px;
    font-family: $museo;
    font-weight: 500;
    text-transform: uppercase;
    text-decoration: none;
    text-align: center;
    border: none;
    cursor: pointer;
    transition: all 0.3s ease;
    overflow: hidden;
    &--blue {
      color: #fff;
      background-color: $blue;
      &:hover {
        background-color: darken($blue, 5);
      }
    }
    &--black {
      color: #fff;
      background-color: $black;
      &:hover {
        background-color: darken($black, 5);
      }
    }
    &--ok {
      width: 225px;
    }
    &--big {
      width: 255px;
      padding: 12px 20px;
    }
    &--no-transform {
      text-transform: unset;
    }
    &--small {
      padding: 10px 27px;
      font-weight: 300;
      text-transform: unset;
    }
    &--smallest {
      padding: 3px 15px 5px;
      font-family: $segoe;
      font-size: 15px;
      text-transform: unset;
    }
  }
</style>